import { PayloadAction } from "@reduxjs/toolkit";
import { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore';
import React, { useEffect, useState } from 'react';
import { Socket, io } from 'socket.io-client';

export type BroadcasterActionsCallback = (data: PayloadAction<any>[]) => void;
export type BroadcasterUpdateCallback = (data: BCUPSinglePayload<any>) => void;
export type BroadcasterDeleteCallback = (data: BCDeletePayload) => void;
export type BroadcasterInsertCallback = (data: BCINSPayload<any>) => void;

export type SliceRegistration = {
    [index: string]: AdapterSlice;
};

export interface BroadcasterContextProps {
    connect: boolean,
    onActions?: BroadcasterActionsCallback;
    onUpdate?: BroadcasterUpdateCallback;
    onDelete?: BroadcasterDeleteCallback;
    onInsert?: BroadcasterInsertCallback;
    userId?: number,
    slices?: SliceRegistration,
    store?: ToolkitStore;
}

const hasManyUpdates = <T,>(p: BCUPPayload<T>): p is BCUPManyPayload<T> => {
    return 'id' in p === false;
};

export const Broadcaster = (props: BroadcasterContextProps & { children: React.ReactNode | React.ReactNode[]; }) => {

    const [connected, setConnected] = React.useState(false);
    const [ioInstance, setIoInstance] = useState<Socket | undefined>(undefined);


    const connect = false;



    useEffect(() => {

        if (!ioInstance) {
            setIoInstance(io());
        }
    }, []);


    useEffect(() => {
        if (ioInstance && props.userId) {
            ioInstance.emit('authaltered');
        }
    }, [props.userId]);

    useEffect(() => {
        if (ioInstance) {

            setConnected(ioInstance.connected);

            ioInstance.on('connect', () => {
                setConnected(ioInstance.connected);
            });
            ioInstance.on('disconnect', () => {
                setConnected(ioInstance.connected);
            });
            ioInstance.on("connect_error", () => {
                setConnected(ioInstance.connected);
            });
            ioInstance.on("error", () => {
                setConnected(ioInstance.connected);
            });
            ioInstance.on("error", () => {
                setConnected(ioInstance.connected);
            });
            ioInstance.on("reconnect", () => {
                setConnected(ioInstance.connected);
            });
            ioInstance.on("reconnect_attempt", () => {
                setConnected(ioInstance.connected);
            });
            ioInstance.on("reconnect_error", () => {
                setConnected(ioInstance.connected);
            });
            ioInstance.on("reconnect_failed", () => {
                setConnected(ioInstance.connected);
            });
            ioInstance?.on('actions', (data: PayloadAction<any>[]) => {
                if (props.onActions) {
                    props.onActions(data);
                }
            });
            ioInstance?.on('update', (data: BCUPPayload<any>) => {
                console.log('broadcast update', data);
                if (props.onUpdate) {
                    if (hasManyUpdates(data)) {
                        data.changes.map(changes => {
                            if (props.onUpdate) {
                                props.onUpdate({
                                    ...changes,
                                    type: data.type
                                });
                            }
                        });
                    } else {
                        props.onUpdate(data);
                    }
                }
                if (props.store && props.slices && data.type in props.slices) {
                    if (hasManyUpdates(data)) {
                        props.store.dispatch(props.slices[data.type].actions.updateMany(data.changes));
                    } else {
                        const { type, ...rest } = data;
                        props.store.dispatch(props.slices[data.type].actions.updateOne(rest));
                    }
                }
            });
            ioInstance?.on('insert', (data: BCINSPayload<any>) => {
                console.log('broadcast insert', data);
                if (props.onInsert) {
                    props.onInsert(data);

                }
                if (props.store && props.slices && data.type in props.slices) {
                    props.store.dispatch(props.slices[data.type].actions.upsertOne(data.data));
                }
            });
            ioInstance?.on('delete', (data: BCDeletePayload) => {
                //console.log('broadcast delete', data);
                if (props.onDelete) {
                    props.onDelete(data);
                }
                if (props.store && props.slices && data.type in props.slices) {
                    props.store.dispatch(props.slices[data.type].actions.removeOne(data.id));
                }
            });
        }
        return () => {
            if (ioInstance) {
                ioInstance.off();
                setIoInstance(undefined);
                setConnected(false);
            }
        };
    }, [ioInstance]);


    return <>{props.children}</>;
};
